import {
  PropsWithChildren,
  ReactElement,
  RefAttributes,
  forwardRef,
} from 'react';

import cs from 'classnames';
import { IonContent } from '@ionic/react';
import { useContextSelector } from 'use-context-selector';
import { useTheme } from 'styled-components';

import { PageContext } from '../../contexts/PageContext';

import { ContentFixed } from './ContentFixed/ContentFixed';
import { ContentSubheader } from './ContentSubheader/ContentSubheader';
import { ContentProgress } from './ContentProgress/ContentProgress';

export type ContentProps = PropsWithChildren<
  {
    padding?: boolean;
    className?: string;
    onScroll?: () => void;
  } & RefAttributes<HTMLIonContentElement>
>;

interface ContentComponent {
  (props: ContentProps): ReactElement<any, any> | null;
  Fixed?: typeof ContentFixed;
  Subheader?: typeof ContentSubheader;
  Progress?: typeof ContentProgress;
}

export const Content = forwardRef<HTMLIonContentElement, ContentProps>(
  ({ onScroll, padding, children, className }, ref) => {
    const { palette } = useTheme();

    const background = useContextSelector(
      PageContext,
      ({ background }) => background
    );

    return (
      <IonContent
        ref={ref}
        onIonScroll={onScroll}
        scrollEvents={!!onScroll}
        style={{ '--background': palette[background] }}
        className={cs(className, { 'ion-padding': padding })}
      >
        {children}
      </IonContent>
    );
  }
) as ContentComponent;

Content.Fixed = ContentFixed;
Content.Subheader = ContentSubheader;
Content.Progress = ContentProgress;
